import { TablePreferencesShape } from '@hooks/useTablePreference';
import { IDB_KEY, IndexedDBConfig, win } from '@utils/win';
import { useMemo } from 'react';
import { getActions, getConnection } from './db';
import { getActionsReturnType } from './types';

// ts-unused-exports:disable-next-line
export interface RecentSelectionsRecord {
  key: string; // Unique identifier for this autocomplete (e.g., "facility-autocomplete")
  selections: Array<{
    id: string | number; // Item ID
    label: string; // Plain text label (for fallback rendering)
    value: anyOk; // Serializable value only (no functions!)
    timestamp: number; // When selected (for sorting/expiry)
  }>;
  maxItems: number; // Config: how many to keep
  lastUpdated: number; // Last modification timestamp
}

// ts-unused-exports:disable-next-line
export async function setupIndexedDB(config: IndexedDBConfig): Promise<void> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise<void>(async (resolve, reject) => {
    try {
      await getConnection(config);
      win[IDB_KEY] = { init: 1, config };
      resolve();
    } catch (e) {
      reject(e);
    }
  });
}

interface StoreTypes {
  tablePref: TablePreferencesShape;
  recentSelections: RecentSelectionsRecord;
}

// ts-unused-exports:disable-next-line
export function useIndexedDBStore<K extends keyof StoreTypes>(
  storeName: K,
): getActionsReturnType<StoreTypes[K]> {
  const _actions = useMemo(
    () => getActions<StoreTypes[K]>(storeName),
    [storeName],
  );
  return _actions;
}
